import TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './filePreview.html?raw';
import GenericDialoge from "../../moreCore/UI/GenericDialog/GenericDialog";
/**
 * Interface für das Widget das die Vererbungslinie angibt um die korrekten Typings zu setzen
 */

import mdsRequire from 'dojo/require'; // documentEditor via registry: breaks the filePreview->documentEditor->_TabEnabledMixin->...->filePreview ESM cycle (TDZ)

import * as filePrviewTypes from "./filePreviewTypes";
import { FileHelpers, TranslationHelpers } from "../../more/Helpers";
class filePreview extends compose(TabEnabledMixin) {
    templateString: any = template;

    private previewWidget: any; // (mds) viewer imports dropped to break the fileViewer<->filePreview ESM base-class cycle
    private previewIco:HTMLElement; //<a>
    private previewFileName:HTMLLabelElement;
    private previewFileAdditionInfo:HTMLLabelElement;
    private previewFileAdditionInfoContainer:HTMLLabelElement;

    private placeholderWidgetContainer:HTMLDivElement;
    private previewWidgetContainer:HTMLDivElement;
    private downloadButtonContainer:HTMLDivElement;
    private fileInfoBar:HTMLDivElement;
    private placeholderTextContainerNoPreview:HTMLDivElement;
    private errorTextContainer:HTMLDivElement;
    private flagShowGenericPreview = true;

    public downloadIsHandledByPreviewWidget = false;

    private fileDownloadUrl:string;
    private fileBase64Data:string;
    private fileName: string;
    private fileDescriptor: FileFinder.FileDescriptorWithBase64;

    private dlg:MdsLax<InstanceType<typeof GenericDialoge>>;
    private downloadFun: (widget: any, filename: string) => void = null;

    private loadingCounter = 0;
    private flagIsLoading = false;

    private oldMinHeight = "";
    private fileConfig: Array<filePrviewTypes.filePreviewConfiguration> = [ //pro tip: code block einklappen rettet leben und augen oder so
        {
            fileExtension: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico', 'apng'],
            icon:"fas fa-file-image",
            createPreviewWidget: (fileBase64Content: string, filename: string, filetype: string)=>{
                let widget = new (mdsRequire('WidgetCollection/fileViewer/imageViewer/imageViewer'))();
                widget.loadImageFromBase64(fileBase64Content, filetype);
                widget.speedModifier.scale = 0.15; //3x so viel
                return widget;
            },
            downloadFileHook:null,
            useReadyFlag: true,
            checkCanUsePreviewWidget: ()=>{
                return (this as any).hasFeature("filePreview", "allowImagePreview");
            },
        },
        {
            fileExtension: ['pdf'],
            icon:"fas fa-file-pdf",
            createPreviewWidget: (fileBase64Content: string, filename: string, filetype: string)=>{
                let widget = new (mdsRequire('WidgetCollection/fileViewer/pdfViewer/pdfViewer'))();
                widget.loadPdfByBase64(fileBase64Content);
                widget.config.ToolbarConfig = {
                    OpenOption: false,
                    PageNavigationTool: true,
                    MagnificationTool: true,
                    PanTool: false,
                    SelectionTool: false,
                    SearchOption: true,
                    PrintOption: true,
                    DownloadOption: false,
                    UndoRedoTool: false,
                    AnnotationEditTool: false,
                    FormDesignerEditTool: false,
                    CommentTool: false,
                    SubmitForm: false,
                    SaveButton: false,
                    ToggleFullScreen:true,
                    YouSignSignature:false,
                };
                widget.config.stickyNotes.enableStickyNotes = true;
                widget.config.pageOrganizerSettings = {
                    enablePageOrganizer: false,
                    canCopy: false,
                    canDelete: false,
                    canImport: false,
                    canInsert: false,
                    canRearrange: false,
                    canRotate: false
                };
                widget.config.cancelDownloads = false;
                widget.config.enableRightClickMenu = false;
                widget.config.experimental["disable_annotation_import_export_menu_click"] = true;
                widget.config.experimental["disablePostingComments"] = true;
                return widget;
            },
            downloadFileHook(widget:any, filename) {
                (widget as any).download(false, null, null, filename);
                return null;
            },
            useReadyFlag:true,
            checkCanUsePreviewWidget: ()=>{
                return (this as any).hasFeature("filePreview", "allowPdfPreview");
            },
        },
        {
            fileExtension: ['doc', 'dot', 'dotx', 'odt', 'ott', 'docx'],
            icon:"fas fa-file-word",
            createPreviewWidget:null,
            downloadFileHook:null,
            useReadyFlag: false,
            checkCanUsePreviewWidget:null,
        },
        {
            fileExtension: ["rtf", "sfdt"],
            icon: "fas fa-file-word",
            createPreviewWidget: (fileBase64Content: string, filename: string, filetype: string)=>{
                let widget = new (mdsRequire('WidgetCollection/fileEditor/documentEditor/documentEditor'))();
                widget.config.isReadOnly = true;
                widget.config.enableToolBar = false;
                widget.config.showSaveButton = false;

                widget.loadDocumentByBase64(fileBase64Content, filetype);

                return widget;
            },
            downloadFileHook: null,
            useReadyFlag: true,
            checkCanUsePreviewWidget: ()=>{
                return (this as any).hasFeature("filePreview", "allowDocumentPreview");
            },
        },
        {
            fileExtension: ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpeg', '3gp', 'ogv'],
            icon:"fas fa-file-video",
            createPreviewWidget: null,
            downloadFileHook: null,
            useReadyFlag: false,
            checkCanUsePreviewWidget: null,
        },
        {
            fileExtension: ['ppt', 'pptx', 'pot', 'potx', 'pps', 'ppsx', 'odp'],
            icon:"fas fa-file-powerpoint",
            createPreviewWidget: null,
            downloadFileHook: null,
            useReadyFlag: false,
            checkCanUsePreviewWidget: null,
        },
        {
            fileExtension: ['xls', 'xlsx', 'xlsm', 'xlt', 'xltx', 'csv', 'ods', 'ots'],
            icon:"fas fa-file-excel",
            createPreviewWidget: null,
            downloadFileHook: null,
            useReadyFlag: false,
            checkCanUsePreviewWidget: null,
        },
        {
            fileExtension: ['csv'],
            icon:"fas fa-file-csv",
            createPreviewWidget: null,
            downloadFileHook: null,
            useReadyFlag: false,
            checkCanUsePreviewWidget: null,
        },
        {
            fileExtension: ['mp3', 'wav', 'aac', 'ogg', 'flac', 'wma', 'm4a', 'amr', 'ra'],
            icon:"fas fa-file-audio",
            createPreviewWidget: null,
            downloadFileHook: null,
            useReadyFlag: false,
            checkCanUsePreviewWidget: null,
        },
        {
            fileExtension: ['zip', 'rar', 'tar', 'gz', '7z', 'bz2', 'xz', 'z'],
            icon: "fas fa-file-archive",
            createPreviewWidget: null,
            downloadFileHook: null,
            useReadyFlag: false,
            checkCanUsePreviewWidget: null,
        },
        {
            fileExtension: ['py', 'js', 'ts', 'cs', 'java', 'cpp', 'c', 'rs', 'bat', 'ps1', 'sh', 'vb', 'vbs', 'vba'],
            icon:"fas fa-file-code",
            createPreviewWidget: null, //einfach vs-code web einbinden Kappa
            downloadFileHook: null,
            useReadyFlag: false,
            checkCanUsePreviewWidget: null,
        },
        {
            fileExtension: ['__FALLBACK__'],
            icon:"fas fa-file",
            createPreviewWidget: null,
            downloadFileHook: null,
            useReadyFlag: false,
            checkCanUsePreviewWidget: null,
        }
    ];
    postCreate(): void {
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    /**
     * Einfache Methode um eine File-Preview anzuzeigen.
     * Fuer mehr Kontrolle setFile()...
     *
     * @param fileDescriptor Descriptor nach Webtool_API_FileTransfer__DownloadDescriptorByKey (GUID, pit-Obj-ID,...)
     * @param [showDownloadButton=true] Ob der Download-Button angezeigt werden soll (Default=True)
     * @param [showAsGenericDlg=false] Ob dieses Widget als GenericDlg angezeigt werden soll
     * @param callback Callback as alternative zu async
     *
     */
    public async show(fileDescriptor: FileFinder.DescriptorRequestData, showDownloadButton=true, showAsGenericDlg=false, callback:Function|null, errorCallback:Function|null){
        this.showLoading(true);
        this.showError(false);
        this.disableDownloadButton(!showDownloadButton);
        let res: FileFinder.FileDescriptorWithBase64;
        try{
            res = await new Promise((resolve, reject) => {
                this.RequestManager.callfunction("Webtool_API_FileTransfer__DownloadDescriptorByKey",
                    fileDescriptor,
                    (response: FileFinder.FileDescriptorWithBase64) => {
                        resolve(response);
                    },
                    (err) => {
                        console.error(err);
                        reject(err);
                    },
                    false
                );
            });
        }catch(err){
            this.showError(true);
            this.showLoading(false);
            this.showToast((err as more.requestErrorMessage).Message, "far fa-dizzy");
            if (typeof errorCallback == 'function'){
                errorCallback(err);
                return;
            }else{
                throw "unable to request file";
                return;
            }
        }



        let fileName = res.filename;
        let fileExtension = "blob";
        if (res.hasOwnProperty("extension")){
            fileName = res.filename + "." + res.extension;
            fileExtension = res.extension;
        }
        //file size formating (addition info)
        let additionInfo = "";
        if (res.hasOwnProperty("filesizeKB")){
            let size = (res.filesizeKB as number) * 1024;
            const bytesUnit = ["b", "kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb", "bb", "gp"]; //i glaub des sollte reichen :)
            for (let unit of bytesUnit){
                additionInfo = String(Math.round((size + Math.pow(2, -52)) * 100) / 100) + unit; // Math.pow(2, -52) ist Number.EPSILON
                if (size < 1024){
                    break;
                }
                size = size / 1024;
            }
        }

        let maybeApreviewWidget: any = this.setFile(fileName, additionInfo, fileExtension, res.base64Content, showAsGenericDlg);
       
        this.showLoading(false);
        if (typeof callback == 'function'){
            callback(maybeApreviewWidget);
        }
        return maybeApreviewWidget;
    }

    showAsDlg() {
        this.dlg = new GenericDialoge();
        this.dlg.closeOnEscape = false; //wegen image viewer
        this.dlg.closeOnEnter = false; //kann evtl. entfernt werden falls es stoert
        this.dlg.setSize("larger");
        this.dlg.show(this, "FilePreview_DlgHeader", null, null, 'close', lang.hitch(this, () => {
            this.emit("dlgClosed");
        }));
    }
    /**
    * Setzt die Datei Vorschau.
    * Es muss  base64Content uebergeben werden, ansonsten exception!
    *
    * @returns Es wird Entweder das Preview Widget zurueckgegeben (`any`) oder `null`.
    */
    public setFileAsDescriptor(filedescriptor: FileFinder.FileDescriptorWithBase64, showAsDlg?: boolean) {
        if (!filedescriptor) return;

        this.fileDescriptor = filedescriptor;
        return this.setFile(filedescriptor.filename, filedescriptor.description, filedescriptor.extension, filedescriptor.base64Content, showAsDlg);
    }
    /**
     * Setzt die Datei Vorschau.
     * Es muss  base64Content uebergeben werden, ansonsten exception!
     *
     * @param filename Dateiname der fuer die Anzeige und evtl. beim Browser Download verwendet wird.
     * @param additionFileInfo Kann weitere Informationen zur Datei beinhalten.
     * @param fileExtension Extension der Datei, anhand davon wird ein Preview Widget verwendet oder auch nicht. Z.B.: "pdf", "jpg",...
     * @param fileContentBase64 Der Heruntergeladene Base64 Inhalt der Datei, wird von Preview Widgets benoetigt.
     *
     * @returns Es wird Entweder das Preview Widget zurueckgegeben (`any`) oder `null`.
     */
    public setFile(filename: string,
        additionFileInfo: string | null,
        fileExtension: string,
        fileContentBase64: string,
        showAsDlg?: boolean): any {
        this.showLoading(true);
        this.showError(false);
        let cont = false;
        if (typeof fileContentBase64 != 'undefined'){
            if (typeof fileContentBase64 == 'string'){
                this.fileBase64Data = fileContentBase64;
                cont = true;
            }
        }
        if (cont == false){
            this.showError(true);
            this.showLoading(false);
            console.error("base64 file content or download url is required!");
            console.trace();
            throw "file preview: base64 file content or download url is required!";
        }

        let usedFileExtension = fileExtension.toLowerCase();
        while (usedFileExtension.indexOf(".") != -1){
            usedFileExtension = usedFileExtension.substring(usedFileExtension.indexOf(".") + 1);
        }

        let usedWidget:any|null = null;

        let matchFound = false;
        let usedConfig:filePrviewTypes.filePreviewConfiguration;
        for (let conf of this.fileConfig){
            if (conf.fileExtension.indexOf(usedFileExtension) != -1){
                matchFound = true;
                usedConfig = conf;
                break;
            }
            if (conf.hasOwnProperty("fileExtension")){
                if (Array.isArray(conf.fileExtension)){
                    if (conf.fileExtension[0] == '__FALLBACK__'){
                        if (matchFound == false){
                            usedConfig = conf; //fallback rauspicken
                            matchFound = true;
                        }
                    }
                }
            }
        }
        if (matchFound == false){
            //sollte im normalfall eigentlich nicht auftretten, da __FALLBACK__ verwendet wird...
            console.error("can't load ANY preview widget!!!");
            throw "can't load ANY preview widget";
            return;
        }

        let useWidgetFlag = false;
        if (typeof usedConfig.checkCanUsePreviewWidget == 'function'){
            useWidgetFlag = usedConfig.checkCanUsePreviewWidget(filename, additionFileInfo, fileExtension, fileContentBase64);
        }
        if ((typeof usedConfig.checkCanUsePreviewWidget == 'undefined') || (usedConfig.checkCanUsePreviewWidget == null)){
            useWidgetFlag = true; //wenn config null dann brauchen wir nix checken
        }

        if ((typeof usedConfig.createPreviewWidget == 'function') && (useWidgetFlag == true)){
            this.previewWidget = usedConfig.createPreviewWidget(fileContentBase64, filename, usedFileExtension);
            this.flagShowGenericPreview = false;
            this.previewWidget.placeAt(this.previewWidgetContainer);

            let properlyWaitingForReady = false;
            if (this.previewWidget.hasOwnProperty("isReady") && (usedConfig.useReadyFlag == true)){
                if (typeof this.previewWidget.isReady == 'boolean'){
                    properlyWaitingForReady = true;
                    if (this.previewWidget.isReady == true){//versteckt placeholder und zeigt preview widget wenn ready
                        this.previewWidgetContainer.classList.remove("w3-hide");
                        this.placeholderWidgetContainer.classList.add("w3-hide");
                    }else{
                        this.showLoading(true);
                        this.oldMinHeight = this.domNode.style.minHeight;
                        this.domNode.style.minHeight = this.domNode.getBoundingClientRect().height + "px"; //wir "freezen" min height damit das layout beim widget austauschen weniger stark bewegt...
                        this.previewWidget.on("ready", lang.hitch(this, ()=>{
                            this.previewWidgetContainer.classList.remove("w3-hide");
                            this.placeholderWidgetContainer.classList.add("w3-hide");
                            this.showLoading(false);
                            this.domNode.style.minHeight = this.oldMinHeight;
                        }));
                    }
                }
            }
            if (properlyWaitingForReady == false){
                //wemn wir nicht auf ready warten koennen, dann sind wir einfach sofot ready...
                this.previewWidgetContainer.classList.remove("w3-hide");
                this.placeholderWidgetContainer.classList.add("w3-hide");
            }

            if (typeof usedConfig.downloadFileHook == 'function'){
                this.downloadIsHandledByPreviewWidget = true;
                this.downloadFun = usedConfig.downloadFileHook;
            }else{
                this.downloadIsHandledByPreviewWidget = false;
            }

        }else{
            this.flagShowGenericPreview = true;
            this.previewWidget = null;
        }

        this.previewIco.setAttribute("class", usedConfig.icon);
        this.fileName = filename;
        this.previewFileName.innerText = filename;
        let additionInfo: string = TranslationHelpers.translate("General_File");
        if (typeof additionFileInfo != 'undefined'){
            if (typeof additionFileInfo == 'string'){
                additionInfo = additionFileInfo;
            }
        }

        this.hideNode(this.previewFileAdditionInfoContainer, !additionInfo);

        this.previewFileAdditionInfo.innerText = additionInfo;
        this.showLoading(false);
        
        if (showAsDlg === true) this.showAsDlg();

        return usedWidget;
    }

    /**
     * Versteckt den Download Button
     *
     * @param [setDownloadButtonDisabled=true] Ob der Download Buton versteckt werden soll.
     */
    public disableDownloadButton(setDownloadButtonDisabled=true){
        if (setDownloadButtonDisabled){
            this.downloadButtonContainer.classList.add("w3-hide");
        }else{
            this.downloadButtonContainer.classList.remove("w3-hide");
        }
    }

    /**
     * Triggered den Download entweder ueber das Preview Widget oder der URL.
     */
    public downloadFile():boolean{
        this.emit("downloadTriggered");
        //fileDownload ueber widget
        if (this.downloadIsHandledByPreviewWidget == true){
            if (typeof this.downloadFun == 'function') {
                this.downloadFun(this.previewWidget, this.fileName);
                this.emit("downloadDone");
                return true;
            }
        }
        //file download ueber url (wenn uebergeben)
        let triggerDownload = false;
        let dlUrl = "";
        if (typeof this.fileDownloadUrl != 'undefined'){
            if (typeof this.fileDownloadUrl == 'string'){
                if (this.fileDownloadUrl != ""){
                    triggerDownload = true;
                    dlUrl = this.fileDownloadUrl;
                }
            }
        }

        //file download ueber base64 zeig
        if (triggerDownload == false) {

            // Umleiten zum Filehelper, falls der komplette descriptor vorhanden ist. Dort wird ggf. die korrekte Downloadmethode gewählt
            if (this.fileDescriptor) {
                FileHelpers.provideFile(this.fileDescriptor, false);
                return;
            }

            if (typeof this.fileBase64Data != 'undefined'){
                if (typeof this.fileBase64Data == 'string'){
                    const byteChars = atob(this.fileBase64Data);
                    const byteNum = new Array(byteChars.length);
                    for (let i = 0; i < byteChars.length; i++){
                        byteNum[i] = byteChars.charCodeAt(i);
                    }
                    const byteArr = new Uint8Array(byteNum);
                    const blob = new Blob([byteArr], { type: "application/octet-stream" }); //da wir davon ausgehen, wenn wir nicht per url oder widget downloaden, dann wissen wir den mimeType nicht...

                    dlUrl = URL.createObjectURL(blob);
                    triggerDownload = true;
                }
            }
        }

        if (triggerDownload){
            const dl = document.createElement('a');
            dl.setAttribute("download", ''); //zusaetzlich
            dl.href = dlUrl;
            dl.download = this.fileName;
            let clickEv = new MouseEvent("click", {
                bubbles: false,
                cancelable: false,
                view: window
            }); //weil dl.click() evtl. auf manchen mobile Geraete nicht funktioniert...
            dl.dispatchEvent(clickEv);
            this.emit("downloadDone");
            return true;
        }
        return false;
    }

    private _onClick_DownloadBtn(ev:Event){
        this.downloadFile();
    }
    private showLoading(setLoading:boolean){
        if (setLoading){
            this.loadingCounter++;
        }else{
            this.loadingCounter--;
        }

        if (this.loadingCounter > 0){
            if (this.flagIsLoading == false){
                this.flagIsLoading = true;
                this.StandbyStart();
            }
        }
        if (this.loadingCounter < 1){
            this.StandbyStop();
            this.flagIsLoading = false;
        }
    }

    private showError(setError:boolean){
        if (setError){
            this.fileInfoBar.classList.add("w3-hide");
            this.placeholderTextContainerNoPreview.classList.add("w3-hide");
            this.errorTextContainer.classList.remove("w3-hide");
        }else{
            this.fileInfoBar.classList.remove("w3-hide");
            this.placeholderTextContainerNoPreview.classList.remove("w3-hide");
            this.errorTextContainer.classList.add("w3-hide");
        }
    }

}

export default mdsWidget(filePreview);
